// @import types
import { CourseSchedulingCourseType, CourseSchedulingStatus } from 'app_types/admin/courseScheduling/courseSchedulingTypes'
import { IHttpResponse } from 'app_types/httpTypes'
// @end

export interface IMyCourse {
  _id: string,
  name: string,
  service_id: string,
  startDate: string,
  endDate: string,
  withoutTutor?: boolean,
  courseScheduling: string,
  teacher?: string
  approval_criteria?: string
  schedulingMode?: {
    id: string
    name: string
  }
  schedulingStatus?: {
    id: string
    name: CourseSchedulingStatus
  }
  certificateCriteria?: string
  certificateCriteriaUrl?: string
  specialServiceConditions?: string
  specialServiceConditionsUrl?: string
  typeCourse?: CourseSchedulingCourseType
  serviceValidity?: number
  enrollmentId?: string
}

export enum IMyCourseTab {
  CURRENT_COURSES =  'current_courses',
  HISTORY_COURSES = 'history_courses'
}

// @add your types
export interface IFetchMyCourses extends IHttpResponse {
  current_courses: Array<IMyCourse>,
  history_courses: Array<IMyCourse>
  nPerPage: number,
  pageNumber: number,
  total_register: number
}
//@end
